import { render, staticRenderFns } from "./SubdomainStatic.vue?vue&type=template&id=a12da7cc&scoped=true&"
import script from "./SubdomainStatic.vue?vue&type=script&lang=js&"
export * from "./SubdomainStatic.vue?vue&type=script&lang=js&"
import style0 from "./SubdomainStatic.vue?vue&type=style&index=0&id=a12da7cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12da7cc",
  null
  
)

export default component.exports